import '@fontsource/gudea';
import './styles/main.scss';
import * as bootstrap from 'bootstrap';

import Packlab from "./js/core/packlab";
import "./js/app";

window.bootstrap = bootstrap;
Packlab.Application.start();
